import React, { useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { CircularProgress, Box } from "@mui/material";
import analyticsService from "../../../../services/analyticsService";
import { AuthContext } from "../../../../authentication/AuthContext";
import { getDateRangeFromFilter } from "../../../../utils/dateFilterUtils";

const PRIMARY_PURPLE = "#6D5DD2";
const SECONDARY_PURPLE = "#9B8BFF";
const GREEN = "#33D6A6";

const DropoffKeywordInsights = ({ filter, preview, full, dateFilterValue }) => {
  const { user } = useContext(AuthContext);
  const [dropoffData, setDropoffData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!user?.client_id) return;
      try {
        setLoading(true);
        const dateRange = getDateRangeFromFilter(dateFilterValue);
        const response = await analyticsService.getDropoffKeywordInsights(
          user.client_id,
          dateRange.start_date,
          dateRange.end_date
        );
        if (response.success && response.data) {
          setDropoffData(response.data);
        }
      } catch (error) {
        console.error("Error fetching drop-off keyword insights:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user?.client_id, dateFilterValue]);

  // Transform API data to chart format
  const labels = dropoffData.map(item => item.user_query || "(empty)");
  const chartData = dropoffData.map(item => item.session_count || 0);

  // Mock resumed sessions for now (can be updated with real data if available)
  const resumeData = chartData.map(count => Math.floor(count * 0.6));

  const series = [
    { name: "Permanent Drop-off", data: chartData },
    { name: "Resumed Session", data: resumeData },
  ];
 
  const options = {
    chart: {
      stacked: true,
      toolbar: { show: false },
    },
    colors: [PRIMARY_PURPLE, GREEN], // Purple + Green
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "60%",
        borderRadius: 1,
        dataLabels: {
          total: {
            enabled: true,
            style: { color: "#000", fontWeight: 600 },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: 600,
        colors: ["#fff"],
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      labels: {
        colors: "#4A4A4A",
      },
      markers: {
        width: 12,
        height: 12,
        radius: 6,
      },
    },
    xaxis: {
      categories: labels,
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
          colors: "#6A6A6A",
        },
      },
    },
    grid: {
      strokeDashArray: 4,
      borderColor: "#E6E6E6",
    },
  };
 
  return (
    <div style={{ paddingTop: full ? "4px" : "0px" }}>
      {full && (
        <>
          <h3 style={{ color: PRIMARY_PURPLE, marginBottom: "4px" }}>
            Drop-off Keyword Insights
          </h3>
          <p style={{ opacity: 0.6, marginTop: 0 }}>
            User drop-offs vs resumed sessions by last message keyword.
          </p>
        </>
      )}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "350px" }}>
          <CircularProgress />
        </Box>
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={preview ? 220 : 350}
        />
      )}
    </div>
  );
};
 
export default DropoffKeywordInsights;